import React from "react";
import { Skeleton } from "antd-mobile";
import { useAdCpt1 } from "@/hooks/adCpt/homeVendor";
import { homeAtom } from "@/atoms/home";
import BaseHour from "./BaseHour";

// 骨架屏样式常量
const SKELETON_STYLES = {
  forecast24hour: { "--width": "100%", "--height": "198px", "--border-radius": "10px" },
};

const HourWeather: React.FC = () => {
  const adPosition21 = useAdCpt1("position-21");
  const homeData = useAtomValue(homeAtom);
  const forecast24hour = homeData?.data?.forecast24hour ?? [];

  return (
    <>
      {/* 24小时天气预报 */}
      {isEmptyType(forecast24hour) ? <Skeleton animated style={SKELETON_STYLES.forecast24hour} /> : <BaseHour />}
      <div data-position="position-21">{adPosition21}</div>
    </>
  );
};

export default HourWeather;
